import { render } from "./FarmQuality.vue?vue&type=template&id=9644438e"
import script from "./FarmQuality.vue?vue&type=script&lang=js"
export * from "./FarmQuality.vue?vue&type=script&lang=js"

import "./FarmQuality.vue?vue&type=style&index=0&id=9644438e&lang=less"

import exportComponent from "/workspace/workdir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__